import React, { Component } from 'react';
import styles from './styles.scss';
import qs from "query-string";
import WJSON from '../../helpers/json';
class Register extends Component 
{
  constructor(props){
    super(props);
    this.state = {};
  }
  componentDidMount(){

  }
  render()
  {

    return (
      <div className={styles.page_container}>
        <div className={styles.auth}>
          <h1>資料驗證成功</h1>
        </div>
      </div>
    );
  }
}

export default Register;


// WEBPACK FOOTER //
// ./src/views/UserProfile/AuthPhone.js